import React from 'react';
import { Navigate } from 'react-router-dom';

const RutasPrivadas = ({ children, allowedRoles }) => {
  const token = sessionStorage.getItem('token');
  const user = JSON.parse(sessionStorage.getItem('user')); 


  if (!token) {
    return <Navigate to="/login" replace />;
  }


  if (allowedRoles && (!user || !allowedRoles.includes(user.role))) {
    return <Navigate to="/unautorized" replace />;
  }

  
  return children;
};

export default RutasPrivadas;
